import { put } from "../../utils/api";
import GenericViewDrawer1 from "./GenericViewDrawer1";
import DocumentItem from "../../Components/Masters/DocumentItem";

const CapitalGoodsViewPage = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString("en-IN") : "—";

  const formatCountryOfManufacture = (value) => {
    if (Array.isArray(value) && value.length > 0) {
      // Handle legacy array data - take first element
      return value[0];
    }
    return value || "—";
  };

  const fields = [
    {
      label: "Purchase Date",
      previous: formatDate(data?.purchaseDate),
      requested: formatDate(data?.editValue?.purchaseDate),
    },
    {
      label: "Capital Goods Category",
      previous: data?.capitalGoodsCategory || "—",
      requested: data?.editValue?.capitalGoodsCategory || "—",
    },
    {
      label: "Name of the Capital Good",
      previous: data?.capitalGoodsName || "—",
      requested: data?.editValue?.capitalGoodsName || "—",
    },
    {
      label: "Vendor/Supplier Name",
      previous: data?.supplierName || "—",
      requested: data?.editValue?.supplierName || "—",
    },
    {
      label: "Quantity Purchased",
      previous:
        data?.quantity ?? "—",
      requested:
        data?.editValue?.quantity ?? "—",
    },
    {
      label: "Total Cost (in USD)",
      previous: data?.cost != null && data?.cost !== "" ? String(data.cost) : "—",
      requested:
        data?.editValue?.cost != null && data?.editValue?.cost !== ""
          ? String(data.editValue.cost)
          : "—",
    },
    {
      label: "Useful Life (Years)",
      previous: data?.usefulLife || "—",
      requested: data?.editValue?.usefulLife || "—",
    },
    {
      label: "Country of Manufacture",
      previous: formatCountryOfManufacture(
        data?.country ?? data?.countryOfManufacture
      ),
      requested: formatCountryOfManufacture(
        data?.editValue?.country ?? data?.editValue?.countryOfManufacture
      ),
    },
    {
      label: "Material Composition",
      previous: data?.materialComposition || "—",
      requested: data?.editValue?.materialComposition || "—",
    },
    {
      label: "Weight of Capital Good (kg)",
      previous: data?.weightOfCapitalGoods || "—",
      requested: data?.editValue?.weightOfCapitalGoods || "—",
    },
    {
      label: "Remark",
      previous: data?.description || "—",
      requested: data?.editValue?.description || "—",
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Capital Goods Details"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
      customDocumentRender={(url, i) => (
        <DocumentItem key={`doc-${i}`} url={url} />
      )}
    />
  );
};

export default CapitalGoodsViewPage;
